<template>
  <transition name="el-fade-in-linear">
	<div v-show="transitionshow">      
	  	
	  <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <!--
          <el-form-item style="width:11%">
          	  <el-select v-model="query.agentbrandid" clearable remote  filterable placeholder="按品牌" @change="query.ischange=true">	            
                    <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	  	  <span style="float: left">{{item.name}}</span>
      				        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                    </el-option>              
              </el-select>          
          </el-form-item>
          -->
          <el-form-item>
              <el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getmatchgoods" @change="query.ischange=true" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getmatchgoods">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="danger" icon="el-icon-edit-outline"  @click="addgoodsmatch">新增匹配</el-button>
          </el-form-item>
	  </el-form>

      <div class="backborder2" style="margin-top:10px">
      <el-table :data="lists" v-loading="query.loading">
	        <el-table-column prop="number" label="天猫商品信息">
              <template slot-scope="scope">
                 <div class="tmall-goods-name">{{scope.row.tmall_name}}</div>
                 <div class="tmall-goods-id">ID：{{scope.row.tmall_productid}}（skuid：{{scope.row.tmall_skuid}}）</div>
              </template>
          </el-table-column>
          <el-table-column prop="number" label="关联宠赞商品信息">
              <template slot-scope="scope">
                 <div class="tmall-goods-name">{{scope.row.name}}</div>
                 <div class="tmall-goods-id">编号：{{scope.row.number}}（单位：{{scope.row.unit}}）</div>
              </template>
          </el-table-column>
          <el-table-column prop="number" width="120" label="操作" align="center">
              <template slot-scope="scope">
                  <el-button type="primary" size="small" circle icon="el-icon-edit" @click="gettmallgoods(scope.row)"/> 
                  <el-button type="warning" size="small" circle icon="el-icon-edit" @click="editczgoods(scope.row)" /> 
              </template>
          </el-table-column>
      </el-table>
      <div class="block">
	        <!--分页begin-->
	        <el-pagination
	            @size-change="pageProductSizeChange"
	            @current-change="pageProductCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="query.rows">
	        </el-pagination>
	        <!--分页end-->
      </div>
      </div>


      <!-- 新增编辑天猫商品信息 -->
      <el-dialog title="新增 / 编辑天猫商品" :visible.sync="addoredittmallgoodsDialog" top="10vh" width="30%">
          <el-form :inline="true" class="demo-form-inline" size="small">
              <el-form-item label-width="140" label="天猫商品名称">
                  <el-input placeholder="请输入天猫商品名称" v-model="addoredittmallgoods.tmall_name" clearable />
              </el-form-item>
              <el-form-item label-width="140" label="天猫商品ID">
                  <el-input placeholder="请输入天猫商品ID" v-model="addoredittmallgoods.tmall_productid" clearable />
              </el-form-item>
              <el-form-item label-width="140" label="天猫商品 sku_id">
                  <el-input placeholder="请输入天猫商品 sku_id" v-model="addoredittmallgoods.tmall_skuid" clearable />
              </el-form-item>
		      </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addoredittmallgoodsDialog = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="addoredittmallgoods.loading" @click="saveorupdategoods">保 存</el-button>
          </div>
      </el-dialog>


      <!-- 匹配宠赞商品信息 -->
      <el-dialog title="匹配宠赞商品信息" :visible.sync="matchgoodsDialog" top="10vh" width="30%">
          <el-form :inline="true" class="demo-form-inline" size="small">
              <el-form-item label-width="140" label="天猫商品名称">
                  <el-input placeholder="请输入天猫商品名称" v-model="matchgoods.tmall_name" clearable :disabled="true"/>
              </el-form-item>
              <el-form-item label-width="140" label="天猫商品ID">
                  <el-input placeholder="请输入天猫商品ID" v-model="matchgoods.tmall_productid" clearable :disabled="true"/>
              </el-form-item>
              <el-form-item label-width="140" label="天猫商品skuid">
                  <el-input placeholder="请输入天猫商品skuid" v-model="matchgoods.tmall_skuid" clearable :disabled="true"/>
              </el-form-item>
              <el-form-item label-width="140" label="关联宠赞商品">
                  <el-button type="primary" size="mini" round icon="el-icon-search" @click="selectgoods">选择商品</el-button>
                  <template>
                      <div class="tmall-product-name">商品名称：{{matchgoods.name}}</div>
                      <div class="tmall-product-number">商品编号：{{matchgoods.number}}</div>
                      <div class="tmall-product-number">
                        单位信息：
                        <el-select v-model="matchgoods.unitid" filterable clearable placeholder="请选择单位" size="small">
                        <el-option v-for="(item,index) in unitlists" :label="item.unit" :value="item.id" :key="index" />
                        </el-select>
                      </div>
                  </template>
              </el-form-item>

		  </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="matchgoodsDialog = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="matchgoods.loading" @click="savematchgoods">保 存</el-button>
          </div>
      </el-dialog>

      <!-- 搜索商品模块 -->
      <product v-model="Tmallproductshow"  @close="closeproduct" @finish="getgoods"/>


    </div>
  </transition>  
</template>

<script>
import product from '@/components/tmall/search/product' //获取搜索商品

export default {
  components: {product},
  data () {
    return {
        url:this.GLOBAL.domain+"Tmall/index",
        actionauth:'', //功能权限
		transitionshow:true,
        brandlists:[],
        brandquery: {
            act:'lists',
            token:this.$cookies.get('token'),
            jdshow:0,
            rollpage:100000,
            rows:0,
	      },
        lists:[],
        query: {
            act:'getmatchgoodslists',
            token:this.$cookies.get('token'),
            agentbrandid:'',
            key:'',
            p:1,
            rollpage:10,
            loading:false,
            ischange:false
        },

        addoredittmallgoods: {
            act:'addtmallgoods',
            token:this.$cookies.get('token'),
            id:'',
            tmall_name:'',
            tmall_productid:'',
            tmall_skuid:'',
            loading:false,
        },
        addoredittmallgoodsDialog:false,
        matchgoods: {
            act:'savematchgoods',
            token:this.$cookies.get('token'),
            id:'',
            tmall_productid:'',
            tmall_name:'',
            productid:'',
            name:'',
            number:'',
            unitid:'',
            loading:false,
        },
        matchgoodsDialog:false,
        Tmallproductshow:false,

        unitlists:[],
		
    }
  },

  watch: {
	  
  },
    
  mounted(){  
      this.getactionauth();
      this.getBrand(); //获取品牌信息
      this.getmatchgoods(); //获取匹配的商品信息
  },
  
  methods:{

    //获取商品单位信息
    getunit(productid) {
        var resource = this.$resource(this.GLOBAL.domain+"Sell/index");		    
        resource.query({act:'getunit',token:this.$cookies.get('token'),productid:productid}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.unitlists = JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
            
        });
    },


    //保存匹配的宠赞商品信息
    savematchgoods() {
        this.matchgoods.loading=true;
        var resource = this.$resource(this.url);		    
        resource.query(this.matchgoods).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.matchgoods.loading=false;
            }else{
                this.matchgoods.loading=false;
                this.matchgoodsDialog=false;
                this.getmatchgoods();
            }
        }).catch((res) => {
            this.matchgoods.loading=false;
        });
    },  


    //选择匹配的商品  
    selectgoods() {
        this.Tmallproductshow=true;
    },

    //关闭选择商品的窗口
    closeproduct() {
        this.Tmallproductshow=false;
    },


    //获取商品信息
    getgoods(item) {
        this.matchgoods.productid=item.id;
        this.matchgoods.name=item.name;
        this.matchgoods.number=item.number;
        this.matchgoods.unitid='';
        //获取商品单位信息
        this.getunit(item.id);
    },


    //修改宠赞商品
    editczgoods(item) {
        this.matchgoodsDialog=true;
        var resource = this.$resource(this.url);		    
        resource.query({act:'getgoodsinfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var data = JSON.parse(Base64.decode(res.data.Data));
                this.matchgoods.id=item.id;
                this.matchgoods.tmall_productid=data.tmall_productid;
                this.matchgoods.tmall_name=data.tmall_name;
                this.matchgoods.productid=data.productid;
                this.matchgoods.name=data.name;
                this.matchgoods.number=data.number;
                this.matchgoods.unitid=data.unitid;

                //获取商品的单位信息
                this.getunit(data.productid);

            }
        }).catch((res) => {
            
        });


    },  

    //获取天猫商品信息
    gettmallgoods(item) {
        this.addoredittmallgoodsDialog=true;
        this.addoredittmallgoods.act='savetmallgoods';
        var resource = this.$resource(this.url);		    
        resource.query({act:'gettmallgoods',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var data = JSON.parse(Base64.decode(res.data.Data));
                this.addoredittmallgoods.id=item.id;
                this.addoredittmallgoods.tmall_name=data.tmall_name;
                this.addoredittmallgoods.tmall_productid=data.tmall_productid;
                this.addoredittmallgoods.tmall_skuid=data.tmall_skuid;
            }
        }).catch((res) => {
            
        });

    },


    //新增天猫商品信息
    saveorupdategoods() {
        this.addoredittmallgoods.loading=true;
        var resource = this.$resource(this.url);		    
        resource.query(this.addoredittmallgoods).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.addoredittmallgoods.loading=false;
            }else{
                this.addoredittmallgoods.loading=false;
                this.addoredittmallgoodsDialog=false;
                this.getmatchgoods();
            }
        }).catch((res) => {
            this.addoredittmallgoods.loading=false;
        });
    },


    //新增修改天猫商品信息
    addgoodsmatch() {
        this.addoredittmallgoods.act='addtmallgoods';
        this.addoredittmallgoods.id='';
        this.addoredittmallgoods.tmall_name='';
        this.addoredittmallgoods.tmall_productid='';
        this.addoredittmallgoods.tmall_skuid='';
        this.addoredittmallgoodsDialog=true;
    },


    //获取功能权限
    getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
        this.actionauth=data;
    },


    /** 获取已匹配的商品信息 **/
    getmatchgoods() {
        if(this.query.ischange) {
            this.query.p=1;
            this.query.rollpage=10;
        }

        this.query.loading=true;
        var resource = this.$resource(this.url);		    
        resource.query(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading=false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.query.rows=parseInt(res.data.count);
                this.query.loading=false;
                if(this.query.ischange) this.query.ischange=false;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.query.loading=false;
        });
    },

    pageProductSizeChange(val) {
        this.query.rollpage = val;
        this.getmatchgoods();
    },
    pageProductCurrentChange(val) {
        this.query.p = val;
        this.getmatchgoods();
    },


    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
        resource.query(this.brandquery).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
        }else{
            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
	


   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.tmall-goods-name {display:inline-block;width:100%;font-size:13px;line-height:23px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;color:#555555}
.tmall-goods-id {display:inline-block;width:100%;font-size:12px;line-height:23px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;color:#999999;font-style:italic;font-weight:200}
.tmall-product-name {width:100%;margin-top:30px;font-size:13px;line-height:21px}
.tmall-product-number {width:100%;font-size:12px;line-height:21px;color:#666666}
</style>


// WEBPACK FOOTER //
// src/components/tmall/TMallGoods.vue